import React, { Component } from 'react';
import EditableTextView from '../../../../../../components/EditableTextView';
import FullScreenImage from '../../../../../../../../components/FullScreenImage';
import OptionItem from './OptionItem';
// import radium from 'radium';
// import Relay from 'react-relay/classic';

const editorOptions = {
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
    ]
  }
};

class QuizFamily extends Component {
  static styles = {};

  onParagraphChange = (itemId, dispatch) => (html) => {
    dispatch('UPDATE_ITEM_DATA', {
      id: itemId,
      paragraph: html
    });
  };

  renderMedia = (item) => {
    if (item.media && item.media && item.media.image && item.media.image.key) {
      return (
        <FullScreenImage
          src={item.media.image.src}
          enableZoom={true}
          alt={item.media.alt || ''}
          placeHolder={item.media.image.placeHolder}
        />
      );
    }
    return null;
  };

  renderAnswers = (item, selected, submitted) => item.answers.map(option => (
    <OptionItem
      lesson={this.props.lesson}
      option={option}
      selected={selected}
      submitted={submitted}
    />
  ));

  render() {
    const {
      lesson: { variant, items }
    } = this.props;
    const { editable, dispatch } = this.props;

    return (
      <div className="QuizFamilyContainer">
        <div>
          <div className="block-knowledge">
            <div className="block-knowledge__container">
              <div className="block-knowledge__row">
                <div className="block-knowledge__col">
                  <div className="block-knowledge__wrapper">
                    <div className="quiz-card">
                      <div className="quiz-card__container">
                        <div className="quiz-card__row">
                          <div className="quiz-card__main">
                            <div className="quiz-card__title brand--body brand--linkColor hide-placeholder">
                              <EditableTextView
                                text={items[0].title}
                                placeholder="Enter text here..."
                                editable={editable}
                                onChange={this.onParagraphChange(items[0].id, dispatch)}
                                editorOptions={editorOptions}
                              />
                            </div>
                            <div className="quiz-card__media">
                              <div className="media-group">{this.renderMedia(items[0])}</div>
                            </div>
                            <div className="quiz-card__answers">{this.renderAnswers(items[0])}</div>
                            <div className="quiz-card__actions">
                              <div className="quiz-card__submit brand--ui">
                                <button className="quiz-card__button quiz-card__button--disabled">
                                  SUBMIT
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="quiz-card__feedback quiz-card__feedback--frame" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QuizFamily;
